export const bulkEditActionTypes = {
  saveBulkEdit: '[Bulk Edit Modal] - save changes',
  confirmBulkEdit: '[Bulk Edit Modal] - confirm changes',
  refreshAfterFinished: '[Bulk Edit Finalized Modal] - refresh data after finalized modal closed',
};
